import { NotificationChannelModel } from "./notificationChannel.model";

export class TimeModel {
    hour: number;
    minute: number;
}

export class ProjectPeriodIntervalModel {
    startTime: TimeModel;
    endTime: TimeModel;
}

export class ProjectPeriodModel {
    name: string;
    intervals?: ProjectPeriodIntervalModel[];
}

export class ProjectModel {
    id: string;
    name: string;
    timezone: string;
    dateformat: string;
    notificationChannels: NotificationChannelModel[];
    periods: ProjectPeriodModel[];
    archived: boolean;
}

export const DateFormatValues = ["yyyy-MM-dd HH:mm:ss", "MM-dd-yyyy HH:mm:ss", "dd-MM-yyyy HH:mm:ss"];
